import { Button, Form, Select, Tag, Input } from "antd";
import Modal from "components/Modal/User/UserModal";
import Table from "components/Table/UsersTable";
import configFile from "config.json";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import styled from "styled-components";
import axios from "utils/axios";
import UserLogModal from "components/Modal/User/UserLogModal";
import { dateFormat } from "utils/format";
import { ArrowRightOutlined, SearchOutlined } from "@ant-design/icons";

//excel
//order,search,filter
//

const tableColumns = [
  {
    title: "Username",
    dataIndex: "Username",
    fixed: "left",
  },
  {
    title: "User Status",
    dataIndex: "UserStatus",
    sorter: (a, b) => a.userStatus?.localeCompare(b.userStatus),
    render: (_) => {
      const color = "geekblue";
      return (
        <Tag color={color} key={_}>
          {_.toUpperCase()}
        </Tag>
      );
    },
  },
  {
    title: "User Create Date",
    dataIndex: "UserCreateDate",
    render: (_) => {
      const date = new Date(_);
      return dateFormat(date);
    },
    sorter: (a, b) =>
      new Date(a["UserCreateDate"]) - new Date(b["UserCreateDate"]),
  },
  {
    title: "User Last Modified Date",
    dataIndex: "UserLastModifiedDate",
    render: (_) => {
      const date = new Date(_);
      return dateFormat(date);
    },
    sorter: (a, b) =>
      new Date(a["UserLastModifiedDate"]) - new Date(b["UserLastModifiedDate"]),
  },
  {
    title: "Enabled",
    dataIndex: "Enabled",
    sorter: (a, b) => {
      `${a["Enabled"]}`.localeCompare(`${b["Enabled"]}`);
    },
    render: (_) => {
      const color = _ ? "green" : "volcano";
      const text = _ ? "TRUE" : "FALSE";
      return (
        <Tag color={color} key={text}>
          {text.toUpperCase()}
        </Tag>
      );
    },
  },
  // {
  //   title: "lastEventCreationDate",
  //   dataIndex: "lastEventCreationDate",
  //   sorter: (a, b) =>
  //     new Date(a["lastEventCreationDate"]) -
  //     new Date(b["lastEventCreationDate"]),
  //   render: (_) => {
  //     const date = new Date(_);
  //     return dateFormat(date);
  //   },
  // },
  // {
  //   title: "lastEventResponse",
  //   dataIndex: "lastEventResponse",
  //   sorter: (a, b) => a.lastEventResponse?.localeCompare(b.lastEventResponse),
  // },
  // {
  //   title: "lastEventType",
  //   dataIndex: "lastEventType",
  //   sorter: (a, b) => a.lastEventType?.localeCompare(b.lastEventType),
  // },
  // {
  //   title: "lastIpAddress",
  //   dataIndex: "lastIpAddress",
  //   sorter: (a, b) => a.lastIpAddress?.localeCompare(b.lastIpAddress),
  // },
];

const tableFilterOptions = {
  username: {
    label: "Username",
    value: "username",
  },
  status: {
    label: "Status",
    value: "status",
    options: [
      {
        label: "Enabled",
        value: "Enabled",
      },
      {
        label: "Disabled",
        value: "Disabled",
      },
    ],
  },
  user_status: {
    label: "User Status",
    value: "user_status",
    options: [
      {
        label: "Unconfirmed",
        value: "Unconfirmed",
      },
      {
        label: "Confirmed",
        value: "Confirmed",
      },
      {
        label: "Unknown",
        value: "Unknown",
      },
      {
        label: "External Provider",
        value: "External_provider",
      },
      {
        label: "Reset Required",
        value: "Reset_required",
      },
      {
        label: "Force Change Password",
        value: "Force_change_password",
      },
    ],
  },
};

const Users = () => {
  const [tableUsers, setTableUsers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [instance, setInstance] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLogModalOpen, setIsLogModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [paginationToken, setPaginationToken] = useState(null);

  useEffect(() => {
    fetchGroupsData();
    fetchUsersData();
  }, []);

  const fetchUsersData = async (paginationToken = null) => {
    try {
      const { filterType, filterValue } = form.getFieldsValue();
      let filters = {};
      if (filterType && filterValue) {
        filters.filter = {
          [filterType]: filterValue,
        };
      }
      if (paginationToken) {
        filters.paginationToken = paginationToken;
      }
      const {
        data: { data: response },
      } = await axios.post(
        `${configFile.PROD_SERVER_URL}/user/filterListUsers`,
        filters
      );
      setTableUsers(response?.["Users"] || []);
      if (response?.["PaginationToken"]) {
        setPaginationToken(response["PaginationToken"]);
      } else {
        setPaginationToken(null);
      }
    } catch (error) {
      NotificationManager.error(
        error.response.data.errorMessage,
        "Error",
        5000
      );
      console.log(error);
    }
  };

  const fetchGroupsData = async () => {
    try {
      const {
        data: { data: groups },
      } = await axios.post(`${configFile.PROD_SERVER_URL}/user/getGroups`);
      setGroups(groups);
    } catch (error) {
      NotificationManager.error(
        error.response.data.errorMessage,
        "Error",
        5000
      );
      console.log(error);
    }
  };
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleInstance = (instance) => {
    const formattedInstance = {
      emailVerified: instance?.["Attributes"].find(
        (item) => item.Name === "email_verified"
      )?.Value,
      username: instance.Username,
      userStatus: instance.UserStatus,
      userCreateDate: instance.UserCreateDate,
      userLastModifiedDate: instance.UserLastModifiedDate,
      enabled: instance.Enabled,
    };
    setInstance(formattedInstance);
    showModal();
  };
  const handleActionLogButton = (instance) => {
    const formattedInstance = {
      username: instance.Username,
      userStatus: instance.UserStatus,
      userCreateDate: instance.UserCreateDate,
      userLastModifiedDate: instance.UserLastModifiedDate,
      enabled: instance.Enabled,
    };
    setInstance(formattedInstance);
    setIsLogModalOpen(true);
  };
  const handleSave = (data) => {
    console.log({ data, instance });
  };
  const handleConfirmSignup = async () => {
    try {
      const user = await axios.post(
        `${configFile.PROD_SERVER_URL}/user/confirmSignUp`,
        {
          username: instance.username,
        }
      );
      NotificationManager.success("Амжилттай хадгаллаа");
      fetchUsersData();
      setIsModalOpen(false);
    } catch (error) {
      NotificationManager.error(error.response.data.errorMessage, "Error");
      console.log(error);
    }
  };
  const handleDisableUser = async () => {
    try {
      const user = await axios.post(
        `${configFile.PROD_SERVER_URL}/user/disableUser`,
        {
          username: instance.username,
        }
      );
      NotificationManager.success("Амжилттай хадгаллаа");
      fetchUsersData();
      setIsModalOpen(false);
    } catch (error) {
      NotificationManager.error(error.response.data.errorMessage, "Error");
      console.log(error);
    }
  };
  const handleEnableUser = async () => {
    try {
      const user = await axios.post(
        `${configFile.PROD_SERVER_URL}/user/enableUser`,
        {
          username: instance.username,
        }
      );
      NotificationManager.success("Амжилттай хадгаллаа");
      fetchUsersData();
      setIsModalOpen(false);
    } catch (error) {
      NotificationManager.error(error.response.data.errorMessage, "Error");
      console.log(error);
    }
  };
  const handleSignOut = async () => {
    try {
      await axios.post(`${configFile.PROD_SERVER_URL}/user/signOut`, {
        username: instance.username,
      });
      NotificationManager.success("Амжилттай гаргалаа");
    } catch (error) {
      NotificationManager.error(error.response.data.errorMessage, "Error");
      console.log(error);
    }
  };

  // Example page change handler for Table component
  const handlePageChange = (page, pageSize) => {
    if (paginationToken) {
      fetchUsersData(paginationToken);
    } else {
      fetchUsersData();
    }
  };

  return (
    <Container>
      {/* {users.length > 0 && ( */}
      <Form form={form}>
        <div className="head">
          <Form.Item
            style={{ width: "300px" }}
            label="Filter"
            name={"filterType"}
          >
            <Select
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label.toLowerCase() ?? "").includes(
                  input.toLowerCase()
                )
              }
              showSearch
              placeholder="Filter type сонгоно уу"
              allowClear
              onChange={() => form.setFieldValue("filterValue", null)}
              options={Object.values(tableFilterOptions).map((option) => ({
                label: option.label,
                value: option.value,
              }))}
            />
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.filterType !== currentValues.filterType
            }
          >
            {({ getFieldValue }) => {
              const filterType = getFieldValue("filterType");
              if (!filterType) return null;

              if (filterType === "username") {
                return (
                  <Form.Item
                    style={{ width: "300px", marginLeft: "16px" }}
                    name="filterValue"
                  >
                    <Input placeholder="Хэрэглэгчийн нэр оруулна уу" />
                  </Form.Item>
                );
              }

              const selectedFilter = Object.entries(tableFilterOptions).find(
                ([key, _]) => key === filterType
              );

              if (selectedFilter) {
                return (
                  <Form.Item
                    style={{ width: "300px", marginLeft: "16px" }}
                    name="filterValue"
                  >
                    <Select
                      placeholder={`${selectedFilter[1].label} сонгоно уу`}
                      allowClear
                      options={selectedFilter[1].options}
                    />
                  </Form.Item>
                );
              }

              return null;
            }}
          </Form.Item>
          <Form.Item style={{ width: "300px", marginLeft: "16px" }}>
            <Button type="primary" onClick={() => fetchUsersData()}>
              <SearchOutlined />
            </Button>
          </Form.Item>
        </div>
      </Form>

      <Table
        users={tableUsers}
        columns={tableColumns}
        handleActionButton={handleInstance}
        handleActionLogButton={handleActionLogButton}
        onChange={handlePageChange}
      />
      {tableUsers.length > 0 && paginationToken && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: "16px 0",
          }}
        >
          <Button
            type="primary"
            onClick={() => fetchUsersData(paginationToken)}
          >
            <ArrowRightOutlined />
          </Button>
        </div>
      )}
      {/* )} */}
      {isModalOpen && (
        <Modal
          isShowModal={isModalOpen}
          setIsShowModal={setIsModalOpen}
          saveButtonText="Хадгалах"
          cancelButtonText="Хаах"
          handleSave={handleSave}
          instance={instance}
          title="хэрэглэгчийн мэдээлэл засах"
          groups={groups}
          handleConfirmSignup={handleConfirmSignup}
          handleDisableUser={handleDisableUser}
          handleEnableUser={handleEnableUser}
          handleSignOut={handleSignOut}
        />
      )}
      {isLogModalOpen && (
        <UserLogModal
          isShowModal={isLogModalOpen}
          setIsShowModal={setIsLogModalOpen}
          title="Лог"
          handleSave={handleSave}
          instance={instance}
          groups={groups}
          handleConfirmSignup={handleConfirmSignup}
          handleDisableUser={handleDisableUser}
          handleEnableUser={handleEnableUser}
        />
      )}
    </Container>
  );
};
const Container = styled.div`
  .head {
    display: flex;
  }
`;
export default Users;
